import React from 'react'
import FormInput from '../../GuestOrder/Components/FormInput'

export default function GuestForm({ name, email, phone, message, onChange }) {
  return (
    <div className="space-y-4">
      <FormInput
        label="Full Name"
        value={name}
        onChange={(e) => onChange('name', e.target.value)}
        required
        placeholder="Your full name"
      />

      <FormInput
        label="Email"
        type="email"
        value={email}
        onChange={(e) => onChange('email', e.target.value)}
        required
        placeholder="your@email.com"
      />

      <FormInput
        label="Phone"
        type="tel"
        value={phone}
        onChange={(e) => onChange('phone', e.target.value)}
        placeholder="Optional phone number"
      />

      <div>
        <label className="block text-white text-sm font-medium mb-2">
          Message (optional)
        </label>
        <textarea
          value={message}
          onChange={(e) => onChange('message', e.target.value)}
          rows={3}
          placeholder="Any special requirements or notes..."
          className="w-full px-4 py-3 rounded-lg border-0 text-gray-900 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 resize-none"
        />
      </div>
    </div>
  )
}
